export const createAccessControlSlice = (set, get) => ({
  plan: null,
  // Mirrors backend shape: entitlements is a flat map of featureId -> DISPLAY_MAP value
  entitlements: {},
  entitlementsHydrated: false,

  setEntitlements: (plan, entitlements) => {
    set({
      plan: plan ?? null,
      entitlements: entitlements || {},
      entitlementsHydrated: true,
    });
  },

  getFeature: (featureId) => {
    const { entitlements } = get();
    return entitlements?.[featureId] ?? false;
  },
});
